<template>
  <div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="cambiarTipoTareaGlobal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Cambiar tipo de tarea global
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12">
              <UsuariosSelectComponent :current="current" />
            </div>
            <div class="col-12">
              <label
                v-bind:class="{
                  'text-danger': current.errors && current.errors.tipo_tarea,
                }"
                >Tipo Tarea</label
              >
              <select
                :disabled="current.estatus == false"
                class="form-control"
                autofocus="autofocus"
                v-model="current.tarea_tipo"
              >
                <option v-for="(c, key) in tarea_tipo" :value="c.id" :key="key">
                  {{ c.nombre }} -
                  <div v-if="c.estatus == true">ACTIVO</div>
                  <div v-if="c.estatus == false">INACTIVO</div>
                </option>
              </select>
              <small
                v-if="current.errors && current.errors.tarea_tipo"
                class="form-text text-danger"
                >{{ current.errors.tarea_tipo[0] }}</small
              >
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="cambiarTipoTareaUsuario()"
              class="btn btn-outline-success"
            >
              <i class="fas fa-save"></i> Guardar
            </button>
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal"
            >
              <i class="fas fa-door-open"></i>
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import UsuariosSelectComponent from "@/components/commons/UsuariosSelectComponent";
import Notifications from "@/notifications/notifications";

export default {
  components: {
    UsuariosSelectComponent,
  },
  data() {
    return {
      tarea_tipo: [],
      current: {
        usuario: "",
        tarea_tipo: "",
        errors: {},
      },

    };
  },
  computed: {},
  mounted() {
    this.refreshTareaTipo();
  },
  methods: {
    refreshTareaTipo() {
      let self = this;
      DynamicService.fetch("wms", "tarea-tipo", {
        quitar_paginacion: true,
      }).then((response) => {
        self.tarea_tipo = response.data;
      });
    },
    resetData() {
      this.current.tarea_tipo = [];
      this.current.usuario = "";
    },
    cambiarTipoTareaUsuario() {
      let self = this;
      DynamicService.postActionList(
        "wms",
        "asignar-tarea-usuario",
        "cambiar_tipo_tarea_x_usuario",
        {
          usuario: self.current.usuario.id,
          tarea_tipo: self.current.tarea_tipo,
        }
      )
        .then((res) => {
          Notifications.alert.success(
            "Cambiar tipo de tarea",
            "Realizado correctamente"
          );
          $("#cambiarTipoTareaGlobal").modal("hide");
          self.resetData();
          this.$emit("refreshData");
        })
        .catch((err) => {
          self.current.errors = err.response.data;
          if (err.response.data.detail) {
            Notifications.alert.error(
              "Cambiar el tipo de tarea",
              err.response.data.detail
            );
          }
        });
    },
  },
};
</script>
